import "./firebase-config";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Mopitction</p>
      </header>
    </div>
  );
}

export default App;
